import { render, staticRenderFns } from "./deleteAffiliateRelation.vue?vue&type=template&id=5aacd7f6"
import script from "./deleteAffiliateRelation.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports